import Consts from '../../consts/clientConsts'
import Position from './Position'

export default class {

        Types = [];
        IsPriceMonitoring = false;

        StartPosition = null;

        Branch = null;

        TradePoints = [];

        Employees = [];

        DisplayTT = null;

        setFilterForParametres(storedFilter, isRouteExist, isTradePointsExist) {
            if (isRouteExist) {
                this.DisplayTT = 4;
                storedFilter.DisplayTts = 4;
                return;
            }

            if (isTradePointsExist) {
                this.DisplayTT = 5;
                storedFilter.DisplayTts = 5;
                return;
            }

            this.DisplayTT = 1;
            storedFilter.DisplayTts = 1;
        }
        
        mapFromDto(employees, isRouteExist, isTradePointsExist, storedFilter) {

            this.StartPosition = new Position().mapFromDto(this.StartPosition);

            if(storedFilter.Employes && storedFilter.Employes.length)
                this.Employees = employees.map(e => new Employee().mapFromDto(e, storedFilter.Employes.some(se => e.DaxUserId == se)));
            else
                this.Employees = employees.map(e => new Employee().mapFromDto(e));

            if ((storedFilter.DisplayTts == 4 && !isRouteExist) || 
                (storedFilter.DisplayTts == 5 && !isTradePointsExist) || 
                (storedFilter.DisplayTts == 2 || storedFilter.DisplayTts == 3 && employees.length == 0))
                this.setFilterForParametres(storedFilter, isRouteExist, isTradePointsExist);

            if(storedFilter.DisplayTts == 4 && isRouteExist) 
                this.DisplayTT = storedFilter.DisplayTts;

            else if(storedFilter.DisplayTts == 5 && isTradePointsExist)
                this.DisplayTT = storedFilter.DisplayTts;

            else if(storedFilter.DisplayTts == 4 && !isRouteExist && isTradePointsExist)
                this.DisplayTT = 5;

            else if(storedFilter.DisplayTts == 5 && !isTradePointsExist)
                this.DisplayTT = 1;

            else if(!employees.length && (storedFilter.DisplayTts == 2 || storedFilter.DisplayTts == 3))
                this.DisplayTT = 1;
            else
                this.DisplayTT = storedFilter.DisplayTts;  
                

            this.Types = Consts.TradePointType.slice(0, -1).map(e => new SelectedType().mapFromDto(e, storedFilter.DisplayedTtTypes.some(t => e.Id == t)));
        }

        setImage(type) {
            return type.Selected 
                        ? `/img/marker${type.Id}.png`
                        : '/img/marker0.png';
        }

        selectType(type) {
            type.Selected = !type.Selected;
        }       

        isMy() {
            return this.DisplayTT == 1 ||
                   this.DisplayTT == 4 ||
                   this.DisplayTT == 5;
        }

        isEmployees() {
            return this.DisplayTT == 2 ||
                   this.DisplayTT == 3;
        }

        createFilterModel(searchText, newCenter = null) {
            let center = newCenter ? newCenter : this.StartPosition;

            return new FilterModel().mapToDto(this.DisplayTT, center, this.Types, searchText, this.Employees, this.IsPriceMonitoring);
        }
}

class SelectedType {
    Id = null;

    Text = null;

    Selected = true;

    mapFromDto(type, selected) {

        this.Id = type.Id;
        this.Text = type.Text;
        this.Selected = selected;

        return this;
    }
}

class Employee {
    
    Id = null;

    DaxUserId = null;

    Fio = null;

    Position = null;

    Checked = false;

    mapFromDto(employee, checked = false) {
        if(!employee)
            return this;

        this.Id = employee.Id;
        this.DaxUserId = employee.DaxUserId;
        this.Fio = employee.Fio;
        this.Position = employee.Position;
        this.Checked = checked;

        return this;
    }
}

class FilterModel {

    MaxCount = Consts.TradePointMaxCount;

    Center = null;

    DisplayedTtTypes = [];
    IsPriceMonitoring = false;

    Employes = null;

    SearchText = null;

    DisplayTts = null;


    mapToDto(displayTts, center, types, searchText = null, employees = null, pm = false) {
        
        this.Center = { Latitude: center.lat, Longitude: center.lng };
        this.DisplayedTtTypes = types.filter(e => e.Selected).map(e => e.Id);        
        this.SearchText = searchText;
        this.DisplayTts = displayTts;
        this.IsPriceMonitoring = pm;

        if(employees && employees.length)
            this.Employes = employees.filter(e => e.Checked).map(e => e.DaxUserId);

        return this;
    }
}